// **********************************************************
// Gallery Slider
// **********************************************************

const gallerySlider = document.querySelectorAll('[data-slider="gallery-slider"]');

const gallerySliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 8,
  speed: 1000,
  pagination: {
    el: '.swiper-progressbar',
    type: 'progressbar',
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  on: {
    slideChange() {
      const currentSlide = this.slides[this.activeIndex];
      const paginationEle = currentSlide.closest('section').querySelector('.gallery-slider__current-slide');
      paginationEle.innerHTML = this.realIndex + 1;
    },
  },
};

const initGallerySlider = () => {
  gallerySlider.forEach((el) => {
    const gallerySliderEle = el.closest('.gallery-slider');
    const arrowRight = gallerySliderEle.querySelector('.swiper-button-next');
    const arrowLeft = gallerySliderEle.querySelector('.swiper-button-prev');
    const progressBarElement = gallerySliderEle.querySelector('.swiper-progressbar');

    gallerySliderOptions.navigation.nextEl = arrowRight;
    gallerySliderOptions.navigation.prevEl = arrowLeft;
    gallerySliderOptions.pagination.el = progressBarElement;

    if (el.swiper) {
      el.swiper.destroy();
    }

    el.swiper = new Swiper(el, gallerySliderOptions);
  });
};

initGallerySlider();

const handleWindowResize = () => {
  const debouncedInitGallerySlider = debounce(initGallerySlider, 500);
  window.addEventListener('resize', debouncedInitGallerySlider);
};

handleWindowResize();
